import { FieldValueType } from '@inpart-io/padme-iap';
import { QCheckbox, QInput } from 'quasar';
import { type Component } from 'vue';

import DatePicker from '@/components/date-picker/date-picker.vue';
import BooleanSelect from '@/components/infogroup-filters/components/boolean-select.vue';
import DateRange from '@/components/infogroup-filters/components/date-range.vue';
import FieldListValueInput from '@/components/infogroup-filters/components/field-list-value-input.vue';
import NumberRange from '@/components/infogroup-filters/components/number-range.vue';
import IufSelect from '@/components/select/iuf-select.vue';

import { CHECKBOX_PROPS, INPUT_MD, INPUT_NUMBER_MD, TEXTAREA_MD } from './ui/inputs.constants';

export const FieldValueTypeComponentMap = new Map<string, Component>([
    [FieldValueType.BOOLEAN, QCheckbox],
    [FieldValueType.DATE, DatePicker],
    [FieldValueType.TEXT, QInput],
    [FieldValueType.LONG_TEXT, QInput],
    [FieldValueType.NUMBER, QInput],
    [FieldValueType.LIST_VALUE, IufSelect]
]);

export const FieldValueTypeDesignTokenMap = new Map<string, Record<string, unknown>>([
    [FieldValueType.BOOLEAN, CHECKBOX_PROPS],
    [FieldValueType.TEXT, INPUT_MD],
    [FieldValueType.LONG_TEXT, TEXTAREA_MD],
    [FieldValueType.NUMBER, INPUT_NUMBER_MD]
]);

export const FiltersFieldValueTypeComponentMap = new Map<string, Component>([
    [FieldValueType.BOOLEAN, BooleanSelect],
    [FieldValueType.DATE, DateRange],
    [FieldValueType.NUMBER, NumberRange],
    [FieldValueType.LIST_VALUE, FieldListValueInput]
]);
